<template>
    <div class="flex flex-col text-base md:flex-row md:justify-between items-center w-full pb-4">
        <div class="flex justify-start items-center w-full">
            <div class="flex justify-start md:justify-center items-center md:w-40 ">
                <img v-if="profileImage" :src="profileImage.pre_signed_image_url" class="rounded-full object-cover border-gray-300 border h-16 w-16" />
                <div v-else class="rounded-full bg-gray-200 border-gray-300 border h-16 w-16"></div>
            </div>
            <div class="flex items-center pt-1">
                <div class="pl-4 md:pl-8 whitespace-nowrap">{{ userFullName }}{{ routeName }}</div>
            </div>
        </div>
        <user-profile-progress 
            class="pl-20 md:pl-0 flex justify-start md:justify-end w-full" 
            :profile-setup-steps="profileSetupSteps"
            :route="route"
         />
    </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import UserProfileProgress from './UserProfileProgress.vue';



const props = defineProps([
    'profileImage',
    'profileSetupSteps',
    'fullName', 
    'route'
])

const visibleProfileProgress = ref(false)

const userFullName = computed(() => {
    return props.fullName ? props.fullName : '--'
})

const routeName = computed(() => {
    return props.route ? ` / ${props.route}` : ''
})
</script>